import { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, {
  Navigation,
  Autoplay,
  Thumbs
} from 'swiper';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/thumbs';
import './styles.css';

import { stepsIcons } from '../../../constants/icons';
import Icon from '../../Atoms/Icon';

const steps = [
  {
    icon: 'document',
    title: 'Upload CV'
  },
  {
    icon: 'comment',
    title: 'Ambitiegesprek'
  },
  {
    icon: 'people',
    title: 'Selectie van mogelijkheden'
  },
  {
    icon: 'comments',
    title: 'Gesprekken bij geselecteerde werkgevers'
  },
  {
    icon: 'rocket',
    title: 'Kies jouw uitdaging!'
  }
];

function Steps() {
  const [thumbsSwiper, setThumbsSwiper] =
    useState<SwiperCore>();
  const duration = 3000;
  return (
    <div className="swiper-button-hidden relative my-16 items-stretch justify-center lg:mt-24">
      <Swiper
        slidesPerView={1}
        slidesPerGroup={1}
        modules={[Autoplay, Thumbs]}
        autoplay={{
          delay: duration,
          disableOnInteraction: false
        }}
        className="hidden-swiper"
        thumbs={{
          swiper:
            thumbsSwiper && !thumbsSwiper.destroyed
              ? thumbsSwiper
              : null
        }}
        breakpoints={{
          1024: {
            autoplay: {
              delay: duration,
              disableOnInteraction: false
            }
          }
        }}
      >
        {steps.map((step) => (
          <SwiperSlide key={steps.indexOf(step)} />
        ))}
      </Swiper>
      <Swiper
        onSwiper={setThumbsSwiper}
        slidesPerGroup={1}
        spaceBetween={0}
        modules={[Thumbs, Navigation]}
        navigation={{
          prevEl: '.swiper-steps-button-prev',
          nextEl: '.swiper-steps-button-next',
          disabledClass: 'swiper-button-disabled'
        }}
        watchSlidesProgress
        breakpoints={{
          1024: {
            slidesPerView: 5,
            centeredSlides: false
          },
          320: {
            slidesPerView: 1,
            centeredSlides: true
          }
        }}
      >
        {steps.map((step) => (
          <SwiperSlide key={steps.indexOf(step)}>
            <div
              key={steps.indexOf(step)}
              className="relative flex flex-col items-center gap-7 lg:gap-5"
            >
              <div className="flex h-24 max-h-24 w-24 items-center justify-center">
                {
                  stepsIcons[
                    step.icon as keyof typeof stepsIcons
                  ]
                }
              </div>
              <div className="step-indicator relative z-10 h-6 w-6 rounded-full border-[3px] border-sl-blue bg-white duration-300" />
              <p className="px-5 text-center text-xl lg:text-lg">
                {step.title}
              </p>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
      <button
        type="button"
        className="swiper-button-prev swiper-steps-button-prev"
      >
        <Icon icon="chevron-left" />
      </button>
      <button
        type="button"
        className="swiper-button-next swiper-steps-button-next"
      >
        <Icon icon="chevron-right" />
      </button>
    </div>
  );
}

export default Steps;
